/**
 * Observes cart fetch activity and dispatches cart-fetch-update event
 */
function monitorCartActivity() {
  const cartObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartChangeRequest = /\/cart\//.test(entry.name);
      
      if (isValidRequestType && isCartChangeRequest) {
        const cartFetchUpdate = new CustomEvent("cart-fetch-update", { detail: "updated" });
        document.dispatchEvent(cartFetchUpdate);
      }
    });
  });
  
  cartObserver.observe({ entryTypes: ["resource"] });
}

/**
 * Reloads cart drawer and cart icon bubble sections
 */
function reloadCartContents() {
  const cartDrawerElement = document.querySelector('#CartDrawer');
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  
  if (cartDrawerElement) {
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(response => response.json())
      .then(sections => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newCartDrawer = doc.querySelector('#CartDrawer');
        
        if (newCartDrawer) {
          cartDrawerElement.innerHTML = newCartDrawer.innerHTML;
          
          const hasItems = newCartDrawer.querySelector('.cart-item');
          if (hasItems && cartDrawerWrapper) {
            cartDrawerWrapper.classList.remove('is-empty');
          } else if (!hasItems && cartDrawerWrapper) {
            cartDrawerWrapper.classList.add('is-empty');
          }
          
          console.log('Cart drawer reloaded');
        }
      })
      .catch(error => {
        console.error('Error reloading cart drawer:', error);
      });
      
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(response => response.json())
      .then(sections => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('.cart-count-bubble');
        const currentBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && currentBubble) {
          currentBubble.outerHTML = newBubble.outerHTML;
        }
      })
      .catch(error => {
        console.error('Error reloading cart bubble:', error);
      });
  }
}

let isSyncing = false;
let lastCartState = null;
let syncTimeout = null;
let pauseSync = false;

/**
 * Triggers engraving service sync with debounce
 */
function syncEngravingServiceQuantity() {
  if (pauseSync) {
    console.log('Sync paused, ignoring request');
    return;
  }
  
  if (syncTimeout) {
    clearTimeout(syncTimeout);
  }
  
  syncTimeout = setTimeout(() => {
    performSync();
  }, 300);
}

/**
 * Syncs engraving service quantity with total engraved products
 */
function performSync() {
  if (isSyncing) {
    console.log('Sync already in progress, skipping');
    return;
  }
  
  isSyncing = true;
  pauseSync = true;
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const currentCartState = JSON.stringify(cart.items.map(item => ({
        id: item.id,
        quantity: item.quantity,
        properties: item.properties
      })));
      
      if (lastCartState === currentCartState) {
        console.log('Cart state unchanged, skipping sync');
        isSyncing = false;
        pauseSync = false;
        return;
      }
      
      lastCartState = currentCartState;
      
      const engravedProducts = cart.items.filter(item => {
        return Object.keys(item.properties || {}).some(key => 
          key.toLowerCase().includes('engraving-text-line')
        );
      });
      
      const totalEngravedQty = engravedProducts.reduce((sum, item) => sum + item.quantity, 0);
      const engravingServiceItem = cart.items.find(item => item.handle === 'engraving-service-fee');
      const engravingServiceLineIndex = cart.items.findIndex(item => item.handle === 'engraving-service-fee');
      
      console.log('Engraved products qty:', totalEngravedQty);
      console.log('Current service qty:', engravingServiceItem?.quantity || 0);
      
      if (totalEngravedQty > 0) {
        if (engravingServiceItem) {
          if (engravingServiceItem.quantity !== totalEngravedQty) {
            console.log(`Updating engraving service quantity from ${engravingServiceItem.quantity} to ${totalEngravedQty}`);
            updateEngravingServiceQuantity(engravingServiceLineIndex + 1, totalEngravedQty);
          } else {
            console.log('Engraving service quantity already correct');
            isSyncing = false;
            pauseSync = false;
          }
        } else {
          console.log('Adding engraving service with quantity:', totalEngravedQty);
          addEngravingService(totalEngravedQty);
        }
      } else {
        if (engravingServiceItem) {
          console.log('Removing engraving service');
          updateEngravingServiceQuantity(engravingServiceLineIndex + 1, 0);
        } else {
          isSyncing = false;
          pauseSync = false;
        }
      }
    })
    .catch(error => {
      console.error('Error syncing engraving service:', error);
      isSyncing = false;
      pauseSync = false;
    });
}

/**
 * Updates engraving service quantity via cart/change endpoint
 */
function updateEngravingServiceQuantity(lineIndex, newQty) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: lineIndex,
      quantity: newQty
    })
  })
  .then(response => response.json())
  .then(cart => {
    console.log('Engraving service quantity updated to:', newQty);
    lastCartState = JSON.stringify(cart.items.map(item => ({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties
    })));
    
    reloadCartContents();
    
    isSyncing = false;
    setTimeout(() => { 
      pauseSync = false;
    }, 200);
  })
  .catch(error => {
    console.error('Error updating engraving service quantity:', error);
    isSyncing = false;
    pauseSync = false;
  });
}

/**
 * Adds engraving service product to cart
 */
function addEngravingService(qty) {
  return fetch('/products/engraving-service-fee.js')
    .then(response => response.json())
    .then(product => {
      if (product.variants && product.variants.length > 0) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: product.variants[0].id,
            quantity: qty
          })
        });
      }
    })
    .then(response => response.json())
    .then((cart) => {
      console.log('Engraving service added with quantity:', qty);
      if (cart && cart.items) {
        lastCartState = JSON.stringify(cart.items.map(item => ({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties
        })));
      }
      
      reloadCartContents();
      
      isSyncing = false;
      setTimeout(() => { 
        pauseSync = false;
      }, 200);
    })
    .catch(error => {
      console.error('Error adding engraving service:', error);
      isSyncing = false;
      pauseSync = false;
    });
}

document.addEventListener('DOMContentLoaded', function() {
  monitorCartActivity();
  setTimeout(() => {
    syncEngravingServiceQuantity();
  }, 500);
});

document.addEventListener("cart-fetch-update", function(e) {
  if (e.detail === "updated") {
    syncEngravingServiceQuantity();
  }
});